import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Link from '@material-ui/core/Link';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import logoBlinket from 'assets/images/new-logo-blinket.svg';
import IUserToken from 'interfaces/tokens/userToken';
import TicketIcon from 'mdi-react/TicketIcon';
import CartOutlineIcon from 'mdi-react/CartOutlineIcon';
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import authService from 'services/auth';
import { APP_BLINKET_URL } from 'settings';

import styles from './styles';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import MenuOutlined from '@ant-design/icons/MenuOutlined';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import DownOutlined from '@ant-design/icons/DownOutlined';
import { Button, Modal } from 'antd';

interface IProps {
  classes?: any;
  user: IUserToken;
  titlePage?: string[];
}

const Header = ({ classes, user }: IProps) => {
  const profileUrl = `${process.env.REACT_APP_ORBITA_URL}/producer/profile/edit`;
  const shoppingUrl = `${process.env.REACT_APP_ORBITA_URL}/producer/shopping`;

  const [anchorElHeaderMenu, setAnchorElHeaderMenu] = useState(null);
  const [anchorElProfile, setAnchorElProfile] = useState(null);
  const [shoppingModalOpen, setShoppingModalOpen] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();

  const handleLogout = () => {
    const useReportWidget = document.getElementById('crowd-shortcut');

    if (useReportWidget) {
      useReportWidget.style.display = 'none';
    }

    if (localStorage.getItem('isSupport')) {
      localStorage.removeItem('isSupport');
    }

    authService.logout();
  };

  const handleCloseHeaderMenu = () => setAnchorElHeaderMenu(null);

  const handleClickHeaderMenu = (event: React.SyntheticEvent) => setAnchorElHeaderMenu(event.currentTarget);

  const handleCloseProfile = () => setAnchorElProfile(null);

  const handleClickProfile = (event: React.SyntheticEvent) => setAnchorElProfile(event.currentTarget);

  const isMarketplaceAvailable = new Date() >= new Date('2025-05-26T00:00:00-03:00');

  return (
    <>
      <AppBar position='fixed' className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.headerMobile}>
            <Button
              type='text'
              onClick={handleClickHeaderMenu}
              aria-label='More'
              aria-owns={Boolean(anchorElHeaderMenu) ? 'header-menu-mobile' : undefined}
              aria-haspopup='true'
              id='header-menu-mobile'
              icon={<MenuOutlined />}
            />
            <img alt='Logo Blinket' src={logoBlinket} className={classes.logoMobile} />
            <Button
              type='text'
              onClick={handleClickProfile}
              aria-label='More'
              aria-owns={Boolean(anchorElProfile) ? 'profile-menu' : undefined}
              aria-haspopup='true'
              id='user-profile-button-mobile'
            >
              {user?.photo ? (
                <img alt='Profile' className={classes.avatarMobile} src={user?.photo} />
              ) : (
                <UserOutlined className={classes.noAvatarIcon} />
              )}
            </Button>
          </div>
          <div className={classes.headerDesktop}>
            <img alt='Logo Blinket' src={logoBlinket} className={classes.logoDesktop} />
            {pathname !== '/my-tickets' && (
              <span className={classes.headerOption} id='header-my-tickets'>
                <Link
                  onClick={() => history.push('/my-tickets')}
                  style={{ textDecoration: 'none', color: '#000000', cursor: 'pointer' }}
                >
                  Meus ingressos
                </Link>
              </span>
            )}
            <div>
              <Button type='text' onClick={() => setShoppingModalOpen(true)} style={{ fontSize: '14px' }}>
                Minhas compras
              </Button>
            </div>
            <div>
              <Button
                type='text'
                href={`${APP_BLINKET_URL}/home?allow_access=1&utm_source=blinket&utm_medium=participante`}
                target='_blank'
                rel='noopener noreferrer'
                style={{ fontSize: '14px' }}
                id='header-create-event'
              >
                Crie seu evento
              </Button>
            </div>
            {isMarketplaceAvailable && (
              <div>
                <Button
                  type='text'
                  href={`${APP_BLINKET_URL}/marketplace`}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ fontSize: '14px' }}
                  id='header-event-marketplace'
                >
                  Marketplace
                </Button>
              </div>
            )}
          </div>
          <div className={classes.alignButtonsDesktop}>
            {user?.photo ? (
              <img alt='Profile' className={classes.avatarDesktop} src={user?.photo} />
            ) : (
              <UserOutlined className={classes.noAvatarIcon} />
            )}
            <span className={classes.color}>{user && user.user_name}</span>

            <Button
              type='text'
              onClick={handleClickProfile}
              aria-label='More'
              aria-owns={Boolean(anchorElProfile) ? 'profile-menu' : undefined}
              aria-haspopup='true'
              id='user-profile-button-desktop'
              icon={<DownOutlined />}
            />

            <div>
              <Menu
                id='profile-menu'
                anchorEl={anchorElProfile}
                open={Boolean(anchorElProfile)}
                onClose={handleCloseProfile}
                disableAutoFocusItem
              >
                <MenuItem id='user-profile-myprofile-option'>
                  <a className={classes.linkStyle} href={profileUrl} target='_blank' rel='noopener noreferrer'>
                    <UserOutlined className={classes.iconStyle} />
                    <span style={{ fontSize: 14 }}>Meu perfil</span>
                  </a>
                </MenuItem>

                <MenuItem onClick={handleLogout} id='user-profile-logout-option'>
                  <LogoutOutlined className={classes.iconStyle} />
                  <span style={{ fontSize: 14 }}>Logout</span>
                </MenuItem>
              </Menu>
            </div>
          </div>
          <div>
            <Menu
              id='header-mobile-menu'
              anchorEl={anchorElHeaderMenu}
              open={Boolean(anchorElHeaderMenu)}
              onClose={handleCloseHeaderMenu}
              disableAutoFocusItem
            >
              <MenuItem id='header-menu-create-event'>
                <a
                  href={`${APP_BLINKET_URL}/home?allow_access=1&utm_source=blinket&utm_medium=participante`}
                  rel='noopener noreferrer'
                  className={classes.linkStyle}
                  id='header-create-event'
                >
                  <PlusOutlined className={classes.iconStyle} />
                  <span style={{ fontSize: 14 }}>Criar Evento</span>
                </a>
              </MenuItem>
              {isMarketplaceAvailable && (
                <MenuItem id='header-menu-event-marketplace'>
                  <a
                    href={`${APP_BLINKET_URL}/marketplace`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className={classes.linkStyle}
                    id='header-event-marketplace'
                  >
                    <PlusOutlined className={classes.iconStyle} />
                    <span style={{ fontSize: 14 }}>Marketplace</span>
                  </a>
                </MenuItem>
              )}
              <MenuItem onClick={() => history.push('/my-tickets')} id='header-menu-my-tickets'>
                <TicketIcon className={classes.iconStyle} /> <span style={{ fontSize: 14 }}>Meus Ingressos</span>
              </MenuItem>
              <MenuItem onClick={() => setShoppingModalOpen(true)}>
                <CartOutlineIcon className={classes.iconStyle} />
                <span style={{ fontSize: '14px' }}>Minhas compras</span>
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Modal
        closable={false}
        open={shoppingModalOpen}
        onCancel={() => setShoppingModalOpen(false)}
        okText='Acessar Minhas Compras'
        cancelText='Cancelar'
        okButtonProps={{ href: shoppingUrl, target: '_blank', onClick: () => setShoppingModalOpen(false) }}
      >
        <p>
          Você será direcionado ao MyEduzz, onde poderá gerenciar suas compras e solicitar reembolsos conforme nossos
          acordos. Não se esqueça de revisar as regras de reembolso antes de continuar. Para mais informações,{' '}
          <a
            href='https://ajuda.eduzz.com/hc/pt-br/articles/4409072315035-Como-posso-solicitar-o-reembolso-da-minha-compra-MyEduzz'
            target='_blank'
          >
            clique aqui
          </a>
          .
        </p>
      </Modal>
    </>
  );
};

export default withStyles(styles)(Header);
